import { Navigate } from 'react-router-dom';
import { isOmegaAdmin } from '@/features/omega/adminMode';
import { Breadcrumbs } from '@/features/omega/Breadcrumbs';
import { OmegaProposalsTile } from '@/features/omega/dashboard/tiles/OmegaProposalsTile';

export function OmegaProposalsPage() {
  if (!isOmegaAdmin()) return <Navigate to="/" replace />;
  return (
    <div className="omega-shell flex flex-col gap-5 pb-8">
      <Breadcrumbs
        crumbs={[{ label: 'OMEGA', to: '/omega' }, { label: 'Proposals' }]}
      />
      <h1 className="text-xl font-semibold text-ink">OMEGA Brain Proposals</h1>
      <OmegaProposalsTile />
    </div>
  );
}
